/** Delimiter between segments in EQM general asset tag strings (upload + parse). */
export const EQM_TAG_SEPARATOR = " :-: ";

/** Composite/Jersey filtered assets end with version segment `... :-: 1`. */
export const EQM_TAG_VERSION_1_SUFFIX = `${EQM_TAG_SEPARATOR}1`;
